// src/precedence/tier.ts
var Tier = {
  USER_OVERRIDE: "user_override",
  USER_BASE: "user_base",
  /** Tenant scope, verified (wire value kept as `customer_override`). */
  CUSTOMER_OVERRIDE: "customer_override",
  /** Tenant scope, unverified (wire value kept as `customer_base`). */
  CUSTOMER_BASE: "customer_base",
  /** Org-wide scope, verified — below tenant, above default. */
  ORG_OVERRIDE: "org_override",
  /** Org-wide scope, unverified. */
  ORG_BASE: "org_base",
  DEFAULT: "default",
  ENTITY_INHERITED: "entity_inherited",
  PROVIDER_CANDIDATE: "provider_candidate"
};
var TIER_WEIGHTS = {
  [Tier.USER_OVERRIDE]: 70,
  [Tier.USER_BASE]: 60,
  [Tier.CUSTOMER_OVERRIDE]: 50,
  [Tier.CUSTOMER_BASE]: 40,
  // FE-only, in the gap: below tenant, above the system default. A wire weight
  // is never 36/33, because the backend has no org tier to emit one.
  [Tier.ORG_OVERRIDE]: 36,
  [Tier.ORG_BASE]: 33,
  [Tier.DEFAULT]: 30,
  [Tier.ENTITY_INHERITED]: 20,
  [Tier.PROVIDER_CANDIDATE]: 10
};
function tierWeight(tier) {
  return TIER_WEIGHTS[tier] ?? TIER_WEIGHTS[Tier.PROVIDER_CANDIDATE];
}

// src/labels/index.ts
var SCOPE_TIER = {
  user: Tier.USER_OVERRIDE,
  tenant: Tier.CUSTOMER_OVERRIDE,
  org: Tier.ORG_OVERRIDE,
  default: Tier.DEFAULT,
  entity: Tier.ENTITY_INHERITED,
  provider: Tier.PROVIDER_CANDIDATE
};
function scopeWeight(scope) {
  return tierWeight(SCOPE_TIER[scope]);
}
var RESOLUTION_ORDER = Object.keys(SCOPE_TIER).sort((a, b) => scopeWeight(b) - scopeWeight(a));
function resolveScalar(layers) {
  for (const scope of RESOLUTION_ORDER) {
    const v = layers[scope];
    if (v != null) return v;
  }
  return void 0;
}
var resolveLabel = resolveScalar;
function mergeLabels(labels) {
  const winners = /* @__PURE__ */ new Map();
  for (const label of labels) {
    const existing = winners.get(label.key);
    if (!existing || scopeWeight(label.scope) > scopeWeight(existing.scope)) {
      winners.set(label.key, label);
    }
  }
  const out = /* @__PURE__ */ new Map();
  for (const [key, label] of winners) {
    if (!label.suppressed) out.set(key, label.value);
  }
  return out;
}
function mergeTags(layers) {
  const ci = layers.caseInsensitive ?? true;
  const norm = (t) => ci ? t.trim().toLowerCase() : t.trim();
  const removed = /* @__PURE__ */ new Set();
  for (const t of layers.remove ?? []) removed.add(norm(t));
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const layer of [layers.user, layers.tenant, layers.org, layers.default]) {
    for (const raw of layer ?? []) {
      const key = norm(raw);
      if (!key || removed.has(key) || seen.has(key)) continue;
      seen.add(key);
      out.push(ci ? key : raw.trim());
    }
  }
  return out;
}

export { SCOPE_TIER, mergeLabels, mergeTags, resolveLabel, resolveScalar, scopeWeight };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map